import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  gap: 8px;
`;

const FinishedRequest = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  background-color: #c2e0f5;
  border-radius: 8px;
  max-width: max-content;
  color: #3b3f51;
  font-size: 14px;
`;

const NewRequest = styled.p`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px;
  background-color: #abefcf;
  border-radius: 8px;
  max-width: max-content;
  color: #3b3f51;
  font-size: 14px;
`;
const Chip = ({ response }) => {
  return (
    <Container>
      {response?.notFinishedRequest && response?.notFinishedRequest > 0 ? (
        <FinishedRequest>
          <i className='hr-Info hrc-blue' />
          Tienes {response?.notFinishedRequest}
          {response?.notFinishedRequest > 1 ? ' solicitudes aprobadas' : ' solicitud aprobada'} sin finalizar la
          creación de la vacante
        </FinishedRequest>
      ) : (
        ''
      )}
      {response?.newRequests && response?.newRequests > 0 ? (
        <NewRequest>
          <i className='hr-Plus hrc-green' /> Tienes {response?.newRequests} nueva
          {response?.newRequests > 1 ? 's solicitudes' : ' solicitud'}
        </NewRequest>
      ) : (
        ''
      )}
    </Container>
  );
};

export default Chip;
